import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../__root";
import { z } from "zod";

export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reset-password",
  validateSearch: z.object({
    email: z.string(),
    salt: z.string(),
    expiresAt: z.number(),
    signature: z.string(),
  }),
}).lazy(() => import("./ResetPassword.lazy").then((d) => d.Route));
